module.exports = __webpack_public_path__ + "img/BoD_12_Mr_William_Liu.fea745bd.jpg";